import { DATA_TESTID, Text_INTERNAL } from "../Text_INTERNAL";
import type { TextInternalProps } from "../Text_INTERNAL";

export const styleProps = {
  size: "text-xl md:text-2xl",
  leading: "leading-8",
  weight: "font-bold",
};

export interface TitleMdProps extends TextInternalProps {
  "data-testid"?: string;
}

export const TitleMd = ({
  color,
  truncate,
  [DATA_TESTID]: dataTestId,
  children,
  ...otherProps
}: TitleMdProps) => {
  const props = {
    ...styleProps,
    color,
    truncate,
    dataTestId,
    ...otherProps,
  };

  return (
    <Text_INTERNAL as="h4" {...props}>
      {children}
    </Text_INTERNAL>
  );
};
